import Alpine from 'alpinejs';
document.addEventListener("alpine:init", () => {
    Alpine.data('contactsIndex', () => ({
        selectedContacts:[],
        selectedContactsDetails: [],
        allContacts: [],
        tagModalOpen: false,
        tagModalMode: "create",
        contactModal: {
            open: false,
            mode: 'view',
        },
        bulkTagModal: {
            open: false,
            mode: 'add',
            selectedTags: [],
        },
        deleteContactsModal: {
            open: false,
        },
        tagName: "",
        tagId: null,
        tags: [], // Holds created tags
        selectedTag: null, // Holds the currently selected tag
        contactDetails: null, // Stores contact details
        lastContactDetails: null,
        errorMessage: "",
        showBulkDropdown: false,
    
        init() {
            this.fetchTags();
            this.readAllContacts();
        },
    
        readAllContacts() {
            //For each name="automation_contact[]" input, get the value and push it to the allContacts array
            document.querySelectorAll('input[name="automation_contact[]"]').forEach(contact => {
                this.allContacts.push(contact.value);
            });
        },
    
        openContactModal(contactId) {
            this.contactModal.open = true;
            this.contactModal.mode = 'view';
            this.contactDetails = null; // Reset previous data
            
            fetch(`/automation_contacts/${contactId}.json`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Failed to fetch contact details.");
                    }
                    return response.json();
                })
                .then(data => {
                    this.contactDetails = data.contact;
                    this.contactDetails.tags = data.tags;
                    this.contactDetails.messages = data.messages;
                    this.lastContactDetails = this.contactDetails;
                    this.scrollMessagesToBottom(); 
                    this.errorMessage = "";
                })
                .catch(error => {
                    this.errorMessage = "Error fetching contact details. Please try again.";
                    console.error(error);
                });
        },
    
        closeContactModal() {
            this.contactModal.open = false;
            this.contactDetails = null;
        },
    
        tagFilterClick(tag_id){
            document.getElementById("selected-tag").value = tag_id;
            document.getElementById("search-form").submit();
        },
    
        openTagModal(mode, tag_name = "", tag_id = null) {
            this.tagName = tag_name;
            this.tagId = tag_id;
            this.errorMessage = "";
            this.tagModalOpen = true;
            this.tagModalMode = mode;
        },
    
        closeTagModal() {
            this.tagModalOpen = false;
            this.errorMessage = "";
            this.tagName = "";
            this.tagId = null;
        },
        
        tagModalHeadline() {
            if( this.bulkTagModal.open && this.bulkTagModal.mode == "add-single" ){
                let contact_name = this.lastContactDetails.ig_username ? "@" + this.lastContactDetails.ig_username : this.lastContactDetails.ig_uid;
                return "Add selected tags to " + contact_name;
            }else if( this.bulkTagModal.open ){
                return this.bulkTagModal.mode === "add" ? "Add selected tags to contacts" : "Remove selected tags from contacts";
            }else{
                return this.tagModalMode === "create" ? "Create new tag" : "Edit Tag";
            }
        },
    
        fetchTags() {
            fetch("/automation_contact_tags")
                .then(response => response.json())
                .then(data => {
                    this.tags = data; // Ensure tags are updated in real-time
                    this.loadSelectedTag();
                });
        },
    
        loadSelectedTag() {
            let tagId = document.getElementById("selected-tag").value;
            if (tagId) {
                let tag = this.tags.find(t => t.id == tagId);
                if (tag) {
                    this.selectedTag = { id: tag.id, name: tag.name };
                }
            }
        },
    
        saveTag() {
            if (this.tagName.trim() === "") {
                this.errorMessage = "Tag name cannot be empty.";
                return;
            }
    
            fetch("/automation_contact_tags", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
                },
                body: JSON.stringify({ automation_contact_tag: { name: this.tagName } })
            })
            .then(response => response.json())
            .then(data => {
                if (data.id) {
                    this.tags.push({ id: data.id, name: data.name });
                    this.tagModalOpen = false;
                } else {
                    this.errorMessage = "Sorry, something went wrong. Please try again.";
                }
            })
            .catch(() => {
                this.errorMessage = "Sorry, something went wrong. Please try again.";
            });
        },
    
        updateTag() {
            if (this.tagName.trim() === "") {
                this.errorMessage = "Tag name cannot be empty.";
                return;
            }
    
            fetch(`/automation_contact_tags/${this.tagId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
                },
                body: JSON.stringify({ automation_contact_tag: { name: this.tagName } })
            })
            .then(response => response.json())
            .then(data => {
                if (data.id) {
                    const index = this.tags.findIndex(tag => tag.id === data.id);
                    if (index !== -1) {
                        this.tags[index].name = data.name;
                    }
                    this.closeTagModal();
                    this.loadSelectedTag();
                } else {
                    this.errorMessage = "Sorry, something went wrong. Please try again.";
                }
            })
            .catch(() => {
                this.errorMessage = "Sorry, something went wrong. Please try again.";
            });
        },
    
        deleteTag() {
            fetch(`/automation_contact_tags/${this.tagId}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.id) {
                    this.tags = this.tags.filter(tag => tag.id !== data.id);
                    this.closeTagModal();
                    document.getElementById("selected-tag").value = "";
                    document.getElementById("search-form").submit();
    
                } else {
                    this.errorMessage = "Sorry, something went wrong. Please try again.";
                }
            })
            .catch(() => {
                this.errorMessage = "Sorry, something went wrong. Please try again.";
            });
        },
    
        deleteMessage(message_id) {
            fetch(`/automation_messages/${message_id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.id) {
                    this.contactDetails.messages = this.contactDetails.messages.filter(message => message.id !== data.id);
                    this.errorMessage = "";
                } else {
                    this.errorMessage = "Sorry, something went wrong. Please try again.";
                }
            })
            .catch(() => {
                this.errorMessage = "Sorry, something went wrong. Please try again.";
            });
        },
        
        scrollMessagesToBottom() {
            this.$nextTick(() => {
              const el = this.$refs.messageScrollContainer;
              if (el) {
                el.scrollTop = el.scrollHeight;
              }
            });
        },
    
        bulkAddTagsToContacts() {
            if (this.bulkTagModal.selectedTags.length === 0) {
                this.errorMessage = "Please select at least one tag to add.";
                return;
            }
    
            const contactIds = this.selectedContacts;
            const tagIds = this.bulkTagModal.selectedTags;
    
            fetch("/automation_contacts/bulk_add_tags", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
                },
                body: JSON.stringify({ contact_ids: contactIds, tag_ids: tagIds })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    this.bulkTagModal.open = false;
                    this.bulkTagModal.selectedTags = [];
                    this.errorMessage = "";
                    if( this.bulkTagModal.mode == 'add-single' ){
                        this.$nextTick(()=>{this.openContactModal(this.lastContactDetails.id)});
                    }
                } else {
                    this.errorMessage = "Sorry, something went wrong. Please try again.";
                }
            })
            .catch(() => {
                this.errorMessage = "Sorry, something went wrong. Please try again.";
            });
        },
    
        bulkRemoveTagsFromContacts() {
            if (this.bulkTagModal.selectedTags.length === 0) {
                this.errorMessage = "Please select at least one tag to remove.";
                return;
            }
    
            const contactIds = this.selectedContacts;
            const tagIds = this.bulkTagModal.selectedTags;
    
            fetch("/automation_contacts/bulk_remove_tags", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
                },
                body: JSON.stringify({ contact_ids: contactIds, tag_ids: tagIds })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    this.bulkTagModal.open = false;
                    this.bulkTagModal.selectedTags = [];
                    this.errorMessage = "";
                    //if selectedTag, reload the page
                    if(this.selectedTag) {
                        document.getElementById("search-form").submit();
                    }
                } else {
                    this.errorMessage = "Sorry, something went wrong. Please try again.";
                }
            })
            .catch(() => {
                this.errorMessage = "Sorry, something went wrong. Please try again.";
            });
        },
    
        bulkDeleteContacts() {
            const contactIds = this.selectedContacts;
    
            fetch("/automation_contacts/bulk_delete", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
                },
                body: JSON.stringify({ contact_ids: contactIds })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    this.deleteContactsModal.open = false;
                    this.selectedContacts = [];
                    this.errorMessage = "";
                    document.getElementById("search-form").submit();
                } else {
                    this.errorMessage = "Sorry, something went wrong. Please try again.";
                }
            })
            .catch(() => {
                this.errorMessage = "Sorry, something went wrong. Please try again.";
            });
        },
    
        removeTagFromContact(tag_id) {
            fetch(`/automation_contacts/${this.contactDetails.id}/remove_tag`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
                },
                body: JSON.stringify({ tag_id: tag_id })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    this.contactDetails.tags = this.contactDetails.tags.filter(tag => tag.id !== tag_id);
                } else {
                    this.errorMessage = "Sorry, something went wrong. Please try again.";
                }
            })
            .catch(() => {
                this.errorMessage = "Sorry, something went wrong. Please try again.";
            });
        },
    
        updateContact() {
            fetch(`/automation_contacts/${this.contactDetails.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
                },
                body: JSON.stringify({ automation_contact: this.cleanContactData() })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    this.lastContactDetails = this.contactDetails;
                    this.contactModal.mode = 'view';
                } else {
                    this.errorMessage = "Sorry, something went wrong. Please try again.";
                }
            })
            .catch(() => {
                this.errorMessage = "Sorry, something went wrong. Please try again.";
            });
        },
    
        cleanContactData() {
            let cleanedData = { ...this.contactDetails };
            delete cleanedData.id; // Rails doesn't allow `id` in strong params
            delete cleanedData.created_at;
            delete cleanedData.updated_at;
            return cleanedData;
        },
    
        formatDate(dateString) {
            if (!dateString) return "Never";
    
            let date = new Date(dateString);
            return date.toLocaleDateString("en-US", {
                month: "short", day: "2-digit", year: "numeric"
            });
        },
        
        toggleSelectAllContacts() {
            if (this.selectedContacts.length === this.allContacts.length) {
                // If all contacts are selected, clear selection
                this.selectedContacts = [];
            } else {
                // Otherwise, select all
                this.selectedContacts = this.allContacts;
            }
        
            this.$nextTick(() => {
                console.log('selectedContacts:', this.selectedContacts);
            });
        },
    
        updateSelectedContactsDetails() {
            this.selectedContactsDetails = [];
            this.selectedContacts.forEach(selectedContactId => {
                const thisContactRow = document.querySelector(`#contact--${selectedContactId}`);
                const thisContactName = thisContactRow.querySelector('.contact-row__name').innerText;
                let thisContactImg = '';
                if( thisContactRow.querySelector('.contact-row__img') ){
                    thisContactImg = thisContactRow.querySelector('.contact-row__img').src;
                }
    
                this.selectedContactsDetails.push({ id: selectedContactId, name: thisContactName, img: thisContactImg });
            });
        }
    }));
    
});